export interface AzureAdModel {
    clientID: string;
    authority: string;
    redirectUri: string;
    cacheLocation: string;
    response_mode: string;
    unprotectedResources: Array<any>;
    protectedResourceMap: Array<any>;
    extraQueryParameters: string;
    applicationId?: string;
    tenant?: string;
    signUpSignInPolicy?: string;
    
}

export interface OAuthSettingsConfig {
    appId ?: string;
    scopes: Array<any>;
    claims ?: any
}

export interface AzureFormPost{
    client_id: any;
    redirect_uri: any;
    scope: any;
    code_verifier: any;
    grant_type: any;
    client_info: any;
}

export interface TenantInformation {
    Id: number;
    TenantName: string;
    TenantIdentifier: string;
    IsActive: boolean;
    TenantID: string;
    ClientID: string;
    ClientSecret: string;
    IsAdEnabled: boolean;
    AdData: any;
    AzureADB2CAuthority: string;
    AzureAdB2CUserflow: string;
    AzureAdType: any;
    OAuthSettings: OAuthSettingsConfig;
}
export interface VerFiedUserModel {
    AccessToken: any;
    TenantId: string;
    ClientId: string;
    ClientSecret: string;
    azureADB2CAuthority: string;
    azureAdB2CUserflow: string;
    azureAdType: any;
    username: string;
    isAgilysysEmployee: boolean;
  }

export interface AdDataModel {
    TenantId: string;
    ClientSecret: string;
    ClientId: string;
    AzureAdType: any;
    AzureADB2CAuthority: string;
    AzureAdB2CUserflow: string;
    AzureAdB2CTenant: string;
    AzureAdB2CSigninOidc: string;
}

export const intialAdDataModel: AdDataModel = {
    TenantId: null,
    ClientSecret: null,
    ClientId: null,
    AzureAdType: null,
    AzureADB2CAuthority: null,
    AzureAdB2CUserflow: null,
    AzureAdB2CTenant: null,
    AzureAdB2CSigninOidc: null
};
export interface AppSettingModel {
    WebAppUrl: string;
    App_CurrentVersion: string;
    App_MinVersion: string;
    App_Size: string;
    Features: Array<any>;
    Api_Url: string;
    AdData: any;
    EnableProductAuthentication: boolean;
    B2CLoginUserFlow: any;
    TenantIdentifier: string;
    DefaultLanguageCode: string; 
    LanguageMasters?: string;     
    RequisitionRequired?: string;
    IsOnPrem?: boolean;
    EditionId?: string;
    EnableClassCalendarIntegration?: string;
    EnableRecipeExtendedCosts?: string;
    ShowTransferAcknowledgement?: string;
    aiFeatureConfiguration?: string;
    PublisherServiceUrl?: string;
};

